<template>
    <div>
        <div class="fin-panel" >

            <van-cell-group>
                <van-field
                        :required=true
                        :border=false
                        readonly
                        clickable
                        label="日期"
                        :value="formModel.finDate"
                        placeholder="请选择"
                        @click="showDatePicker = true"
                />
                <van-popup v-model="showDatePicker" position="bottom">
                    <van-datetime-picker
                            v-model="pickDate"
                            type="date"
                            :min-date="minDate"
                            :max-date="maxDate"
                            @cancel="showDatePicker = false"
                            @confirm="onDateConfirm"
                    />
                </van-popup>
            </van-cell-group>
            <van-cell-group>
                <van-field
                        readonly
                        :required=true
                        clickable
                        label="时间"
                        :value="formModel.finTime"
                        placeholder="请选择"
                        @click="showTimePicker = true"
                />
                <van-popup v-model="showTimePicker" position="bottom">
                    <van-datetime-picker
                            v-model="pickTime"
                            type="time"
                            :min-hour="0"
                            :max-hour="24"
                            @cancel="showTimePicker = false"
                            @confirm="onTimeConfirm"
                    />
                </van-popup>
            </van-cell-group>
            <van-cell-group>
                <van-field  readonly
                            type="text" label="金额"
                            placeholder="请录入金额"
                            :required=true
                            clickable
                            :value="formModel.amount"
                            @touchstart.native.stop="showKeyboard = true"
                />
                <van-number-keyboard
                        :show="showKeyboard"
                        v-model="formModel.amount"
                        extra-key="."
                        close-button-text="完成"
                        @blur="showKeyboard = false"
                />
            </van-cell-group>

            <van-cell-group >
                <van-field
                        readonly
                        clickable
                        label="在途账单"
                        :value="transFin"
                        placeholder="请选择"
                        @click="showTransFinPicker = true"
                />
                <van-popup v-model="showTransFinPicker" position="bottom">
                    <van-picker show-toolbar title="在途账单" ref="transFinPicker"
                                :columns="transFinList"
                                value-key="finName"
                                @cancel="showTransFinPicker = false"
                                @confirm="onTransFinConfirm"/>
                </van-popup>
            </van-cell-group>

            <van-cell-group>
                <van-field
                        readonly
                        clickable
                        label="分类"
                        :value="finType"
                        placeholder="请选择"
                        @click="showFinTypePicker = true"
                />
                <van-popup v-model="showFinTypePicker" position="bottom" >
                    <van-picker
                            show-toolbar title="分类" ref="finTypePicker"
                            :columns="finTypes"
                            value-key="attrName"
                            @cancel="showFinTypePicker = false"
                            @confirm="onFinTypeConfirm"
                    />
                </van-popup>

            </van-cell-group>

            <van-cell-group>
                <van-field
                        v-model="formModel.remark"
                        rows="2"
                        autosize
                        label="备注"
                        type="textarea"
                        maxlength="50"
                        placeholder="请输入备注"
                        show-word-limit
                />

            </van-cell-group>

            <van-button style="margin-top: 10px;" type="primary"
                        block round color="#fe7844" :loading="isLoading"
                        loading-text="提交中..."
                        @click="submitForm">提交</van-button>


        </div>
    </div>
</template>

<script>
    import {formatDate,stringToDate} from '../../common/utils/dateUtil.js'
    import * as MyApi from '../../api/URLApiAddr.js'
    import * as BusiConsts from '../../common/BusiConsts.js'
    import store from '@/store'

    export default {
        name: 'TranceFinanceDetail',
        components: {
        },
        data() {
            return {
                active: [],
                isLoading: false,
                formModel:{
                    transFinId:'',
                    finId: this.$route.params.finId,
                    amount: '',
                    remark:'',
                    inputDate:formatDate(new Date,'yyyy-MM-dd'),
                    month:formatDate(new Date,'yyyy-MM'),
                    finDate:formatDate(new Date,'yyyy-MM-dd'),
                    finTime:formatDate(new Date,'hh:mm'),
                    transFin: '',
                    finType: ''
                },
                month:'',
                pickDate:new Date(),
                showDatePicker:false,
                minDate: new Date(2020, 0, 1),
                maxDate: new Date(2025, 10, 1),
                pickTime:formatDate(new Date,'hh:mm'),
                showTimePicker:false,
                remark: '',
                transFin: '',
                transFinList: [],
                showTransFinPicker: false,
                showKeyboard: false,
                finType: '',
                finTypes: [],
                showFinTypePicker: false
            }
        },
        created:function() {
            this.initData()
        },
        methods:{
            initData(){
                this.$axios.get(MyApi.QRY_TRANS_FIN_LIST).then((response) => {
                    let data = response.data
                    if(data.length > 0){
                        this.formModel.finId = data[0].finId
                        this.transFin = data[0].finName
                        this.transFinList.push({values:data});
                    }else{
                        this.$toast.fail("没有在途账单");
                    }
                }).catch((error) => {
                    // eslint-disable-next-line no-console
                    console.log(error)
                    this.$toast.fail("在途列表数据初始化异常");
                })

                let params = {attrIds:[12]}
                this.$axios.post(MyApi.QRY_ATTR_LIST_BY_PARID,params).then((resp) => {
                    let type = resp.data.finType
                    this.finTypes.push({values:type,defaultIndex:1});
                    this.formModel.finType = type[1].attrId
                    this.finType = type[1].attrName

                }).catch((error) => {
                    console.log(error)
                    this.$toast.fail("类型数据初始化异常");
                })

            },

            onDateConfirm(value) {
                this.formModel.finDate = formatDate(value,'yyyy-MM-dd');
                this.formModel.month = formatDate(value,'yyyy-MM');
                this.showDatePicker = false;
            },
            onTimeConfirm(value) {
                this.formModel.finTime = value;
                this.showTimePicker = false;
            },
            submitForm() {
                this.isLoading = true
                // let params = this.model
                // thisVue.buttonDisabled = true
                //let toast = thisVue.showToast()

                debugger;
                let params = this.formModel
                this.$axios.post(MyApi.TRANS_FINANCE_SAVE_URL,params/*,options*/)
                // 请求成功后
                    .then((data) => {
                        //let data = response.data;
                        if('200' == data.code){
                            this.formModel.amount = ''
                            this.formModel.remark = ''
                            this.$toast.success(data.msg);
                        }
                        this.isLoading = false
                    })
                    .catch((err) => {
                        this.isLoading = true
                        this.$toast.fail("请求异常,请稍后再试");
                    })
            },

            onTransFinConfirm(value){
                this.formModel.finId = value[0].finId;
                this.transFin = value[0].finName ;
                this.showTransFinPicker = false
            },
            onFinTypeConfirm(value){
                this.formModel.finType = value[0].attrId;
                this.finType = value[0].attrName ;
                this.showFinTypePicker = false
            }

        }

    };
</script>



<style>
    .fin-panel {
        min-width: 120px;
        font-size: 20px;
        line-height: 36px;
        margin-left: 15px;
        margin-right: 15px;
        margin-bottom: 60px;
    }

</style>
